import { ColorType, useTheme } from "./AHTheme/AHTheme";
import { IconSize, useLayoutContext } from "./LayoutProvider";

import { BoxProps } from "./AHTheme/BoxProps";
import { Ionicons } from "@expo/vector-icons";
import React from "react";

import { useBoxStyle } from "./AHTheme/useBoxStyle";
import { useScaleFactor } from "./AHScaleFactor";
import { RoutineIcon } from "../globalTypes";

function asertNever(_: never) {
  console.warn("No implementation for todo category icon");
}

type RoutineIconProps = {
  type: RoutineIcon | keyof typeof RoutineIcon;
  size?: IconSize;
  color?: ColorType;
  customColor?: string;
} & Omit<BoxProps, "color">;

export function AHRoutineIcon(props: RoutineIconProps) {
  const { color: c, size: s, customColor, ...boxProps } = props;
  const boxStyle = useBoxStyle(boxProps);
  const theme = useTheme();
  const layout = useLayoutContext();
  const color = customColor ?? theme[c ?? "darkerText"];
  const sf = useScaleFactor();
  const size = layout.icon[s ?? "small"] * sf;

  switch (props.type) {
    case RoutineIcon.shelf_hole:
    case "shelf_hole":
      return (
        <Ionicons
          style={boxStyle}
          name="albums-outline"
          color={color}
          size={size}
        />
      );

    case RoutineIcon.residual:
    case "residual":
      return (
        <Ionicons
          style={boxStyle}
          name="cart-outline"
          color={color}
          size={size}
        />
      );

    case RoutineIcon.waste:
    case "waste":
      return (
        <Ionicons
          style={boxStyle}
          name="trash-outline"
          color={color}
          size={size}
        />
      );
    case RoutineIcon.key:
    case "key":
      return (
        <Ionicons
          style={boxStyle}
          name="key-outline"
          color={color}
          size={size}
        />
      );
    default:
      asertNever(props.type);
      return null;
  }
}
